<app-offline-message />
<ngx-loading-bar />
<router-outlet />
